const AUTH_PATHS = new Set([
  '/sub/login',
  '/sub/passwordlogin',
  '/sub/register',
  '/sub/refindpsw',
])

// 暫時沿用折扣碼開關，只限制明確關閉折扣碼的台灣店鋪。
export function shouldHideStorefrontLogin(config, templateKey) {
  if (templateKey !== 'default') return false
  const value = config?.showDiscountCode
  return value === false || value === 0
    || (typeof value === 'string' && ['false', '0'].includes(value.trim().toLowerCase()))
}

function getLinkPath(link) {
  if (typeof link !== 'string' || !link.trim()) return ''
  const value = link.trim()
  if (!value.startsWith('/') && !/^https?:\/\//i.test(value)) return ''
  try {
    return new URL(value, 'https://storefront.invalid').pathname.replace(/\/+$/, '').toLowerCase()
  } catch {
    return ''
  }
}

export function isStorefrontAuthPath(path) {
  return AUTH_PATHS.has(getLinkPath(path))
}

export function isStorefrontLoginEntry(config = {}) {
  const clickConfig = config?.clickConfig
  const interaction = clickConfig?.responseType
    && (!['link', 'jumpLink'].includes(clickConfig.responseType) || clickConfig.link)
    ? clickConfig
    : config
  if (interaction?.responseType && !['link', 'jumpLink'].includes(interaction.responseType)) return false
  const path = getLinkPath(interaction?.link)
  // 頭部後台配置的人像圖片實際連到會員中心，匿名訪客會再被導向登入。
  return AUTH_PATHS.has(path) || path === '/sub/user' || path === '/sub/user/profile'
}
